import BButton from 'components/common/BButton';
import TranslatedLink from 'components/common/TranslatedLink';
import SearchNotFoundIllustration from 'components/Icons/illustrations/search/notFound.svg';
import { useLocale } from 'hooks/useLocale';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';
import { linkService } from 'services/LinkService';

interface VehicleListEmptyPlaceholderProps {
  wrapperClasses?: string;
}

const VehicleListEmptyPlaceholder: FunctionComponent<
  VehicleListEmptyPlaceholderProps
> = ({ wrapperClasses }) => {
  const { t } = useTranslation('search');
  const { locale } = useLocale();
  const actionLink = linkService.generateCategoryLink({ locale });
  return (
    <div className={wrapperClasses}>
      <div className="flex flex-col items-center gap-4 rounded-3xl border p-6 md:flex-row">
        <SearchNotFoundIllustration className="w-60" />
        <div className="mx-auto">
          <div className="text-xl font-medium">{t('notFound.title')}</div>
          <div className="mt-2 text-lg text-slate-500 ">
            {t('notFound.description')}
          </div>
          <TranslatedLink href={actionLink}>
            <a>
              <BButton className="mt-4">{t('notFound.cta')}</BButton>
            </a>
          </TranslatedLink>
        </div>
      </div>
    </div>
  );
};

export default VehicleListEmptyPlaceholder;
